export default __webpack_public_path__ + "static/mask-apl-0a546ee00133d8defc1b94cdf93b6ab6.png";